/* eslint-disable */
import { gsap, TweenLite } from "gsap/all";

const $mobile = document.getElementById('mobileImg');

if ($mobile) {
  document.addEventListener('mousemove', (event) => {
    const xPos = (event.clientX / window.innerWidth) - 0.5;
    const yPos = (event.clientY / window.innerHeight) - 0.5;

    TweenLite.to($mobile, 1, {
      x: xPos * 30,
      y: yPos * 30,
      rotate: xPos * 3 - 1, // Rotation logic with coefficients
      ease: 'power1.out',
      // Uncomment for additional effects:
      // skewY: yPos * 3,
      // skewX: xPos * 10,
      // rotateY: yPos * 55,
    });
  });
}



// WEBPACK FOOTER //
// ./scripts/js/mobilemove.js